import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import './Footer.css';

const XIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.731-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const LINKS = {
  Product: [
    { label: 'Features', to: '/#features' },
    { label: 'Tools Catalog', to: '/tools' },
    { label: 'Pricing', to: '/pricing' },
    { label: 'Changelog', to: '#' },
  ],
  Company: [
    { label: 'About', to: '#' },
    { label: 'Blog', to: '/blog' },
    { label: 'Careers', to: '#', badge: 'Hiring' },
    { label: 'Press Kit', to: '#' },
  ],
  Legal: [
    { label: 'Privacy Policy', to: '#' },
    { label: 'Terms of Service', to: '#' },
    { label: 'Cookie Policy', to: '#' },
  ],
};

const GithubIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z"/>
  </svg>
);
const LinkedinIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const SOCIALS = [
  { icon: XIcon, label: 'X', href: '#' },
  { icon: GithubIcon, label: 'GitHub', href: '#' },
  { icon: LinkedinIcon, label: 'LinkedIn', href: '#' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="divider" />
      <div className="footer__inner section-inner">
        <div className="footer__top">
          <div className="footer__brand">
            <Link to="/" className="navbar__logo" style={{ marginBottom: '16px', display: 'inline-flex' }}>
              <div className="navbar__logo-icon"><img src="/brain-64.png" alt="ToolMind" className="navbar__logo-img" /></div>
              <span className="navbar__logo-text">ToolMind</span>
              <span className="navbar__logo-badge">AI</span>
            </Link>
            <p className="footer__tagline">
              Discover the right tools for every workflow — powered by AI that learns what you actually need.
            </p>
            <div className="footer__socials">
              {SOCIALS.map(({ icon: Icon, label, href }) => (
                <a key={label} href={href} aria-label={label} className="footer__social">
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          <div className="footer__cols">
            {Object.entries(LINKS).map(([col, items]) => (
              <div key={col} className="footer__col">
                <p className="footer__col-title">{col}</p>
                <ul>
                  {items.map(({ label, to, badge }) => (
                    <li key={label}>
                      <Link to={to} className="footer__col-link">
                        {label}
                        {badge && <span className="footer__badge">{badge}</span>}
                        {to === '#' && <ArrowUpRight size={12} className="footer__ext" />}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="divider" style={{ margin: '40px 0' }} />

        <div className="footer__bottom">
          <p className="footer__copy">© {new Date().getFullYear()} ToolMind, Inc. All rights reserved.</p>
          <p className="footer__copy">Built with <span style={{ color: 'var(--brand-a)' }}>♥</span> for builders, by builders.</p>
        </div>
      </div>
    </footer>
  );
}
